/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BillRouteImport } from './routes/bill'
import { Route as MenuRouteImport } from './routes/menu'
import { Route as OrdersRouteImport } from './routes/orders'
import { Route as SsoCallbackRouteImport } from './routes/sso-callback'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TablesRouteImport } from './routes/tables'
import { Route as JoinIndexRouteImport } from './routes/join.index'
import { Route as JoinCodeRouteImport } from './routes/join.$code'
import { Route as MenuIndexRouteImport } from './routes/menu.index'
import { Route as MoreIndexRouteImport } from './routes/more.index'
import { Route as MoreActivityRouteImport } from './routes/more.activity'
import { Route as MoreBillingRouteImport } from './routes/more.billing'
import { Route as MoreDayCloseRouteImport } from './routes/more.day-close'
import { Route as MoreDeviceRouteImport } from './routes/more.device'
import { Route as MoreOrderingRouteImport } from './routes/more.ordering'
import { Route as MoreProfileRouteImport } from './routes/more.profile'
import { Route as MoreStaffRouteImport } from './routes/more.staff'
import { Route as MoreSubscriptionRouteImport } from './routes/more.subscription'
import { Route as MoreSwitchRouteImport } from './routes/more.switch'
import { Route as MoreTablesRouteImport } from './routes/more.tables'
import { Route as OrdersIndexRouteImport } from './routes/orders.index'
import { Route as OrdersOrderIdRouteImport } from './routes/orders.$orderId'
import { Route as OrdersKotsRouteImport } from './routes/orders.kots'
import { Route as OrdersNewRouteImport } from './routes/orders.new'
import { Route as MenuAddonsIndexRouteImport } from './routes/menu.addons.index'
import { Route as MenuAddonsGroupIdRouteImport } from './routes/menu.addons.$groupId'
import { Route as MenuAddonsNewRouteImport } from './routes/menu.addons.new'
import { Route as MenuCategoriesIndexRouteImport } from './routes/menu.categories.index'
import { Route as MenuCategoriesCategoryIdRouteImport } from './routes/menu.categories.$categoryId'
import { Route as MenuCategoriesNewRouteImport } from './routes/menu.categories.new'
import { Route as MenuItemsItemIdRouteImport } from './routes/menu.items.$itemId'
import { Route as MenuItemsNewRouteImport } from './routes/menu.items.new'
import { Route as MoreBillsIndexRouteImport } from './routes/more.bills.index'
import { Route as MoreBillsBillIdRouteImport } from './routes/more.bills.$billId'
import { Route as MoreOffersIndexRouteImport } from './routes/more.offers.index'
import { Route as MoreOffersOfferIdRouteImport } from './routes/more.offers.$offerId'
import { Route as MoreOffersNewRouteImport } from './routes/more.offers.new'
import { Route as MorePrintersIndexRouteImport } from './routes/more.printers.index'
import { Route as MorePrintersPrinterIdRouteImport } from './routes/more.printers.$printerId'
import { Route as MorePrintersBridgeRouteImport } from './routes/more.printers.bridge'
import { Route as MorePrintersJobsRouteImport } from './routes/more.printers.jobs'
import { Route as MorePrintersNewRouteImport } from './routes/more.printers.new'
import { Route as MoreReportsIndexRouteImport } from './routes/more.reports.index'
import { Route as MoreReportsReportRouteImport } from './routes/more.reports.$report'
import { Route as OrdersOrderIdBillRouteImport } from './routes/orders.$orderId_.bill'
import { Route as OrdersOrderIdPayRouteImport } from './routes/orders.$orderId_.pay'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillRoute = BillRouteImport.update({
  id: '/bill',
  path: '/bill',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuRoute = MenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersRoute = OrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => rootRouteImport,
} as any)
const SsoCallbackRoute = SsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportRoute = SupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any)
const TablesRoute = TablesRouteImport.update({
  id: '/tables',
  path: '/tables',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinIndexRoute = JoinIndexRouteImport.update({
  id: '/join/',
  path: '/join/',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinCodeRoute = JoinCodeRouteImport.update({
  id: '/join/$code',
  path: '/join/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const MenuIndexRoute = MenuIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MenuRoute,
} as any)
const MoreIndexRoute = MoreIndexRouteImport.update({
  id: '/more/',
  path: '/more/',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreActivityRoute = MoreActivityRouteImport.update({
  id: '/more/activity',
  path: '/more/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreBillingRoute = MoreBillingRouteImport.update({
  id: '/more/billing',
  path: '/more/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreDayCloseRoute = MoreDayCloseRouteImport.update({
  id: '/more/day-close',
  path: '/more/day-close',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreDeviceRoute = MoreDeviceRouteImport.update({
  id: '/more/device',
  path: '/more/device',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreOrderingRoute = MoreOrderingRouteImport.update({
  id: '/more/ordering',
  path: '/more/ordering',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreProfileRoute = MoreProfileRouteImport.update({
  id: '/more/profile',
  path: '/more/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreStaffRoute = MoreStaffRouteImport.update({
  id: '/more/staff',
  path: '/more/staff',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreSubscriptionRoute = MoreSubscriptionRouteImport.update({
  id: '/more/subscription',
  path: '/more/subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreSwitchRoute = MoreSwitchRouteImport.update({
  id: '/more/switch',
  path: '/more/switch',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreTablesRoute = MoreTablesRouteImport.update({
  id: '/more/tables',
  path: '/more/tables',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrdersRoute,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => OrdersRoute,
} as any)
const OrdersKotsRoute = OrdersKotsRouteImport.update({
  id: '/kots',
  path: '/kots',
  getParentRoute: () => OrdersRoute,
} as any)
const OrdersNewRoute = OrdersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OrdersRoute,
} as any)
const MenuAddonsIndexRoute = MenuAddonsIndexRouteImport.update({
  id: '/addons/',
  path: '/addons/',
  getParentRoute: () => MenuRoute,
} as any)
const MenuAddonsGroupIdRoute = MenuAddonsGroupIdRouteImport.update({
  id: '/addons/$groupId',
  path: '/addons/$groupId',
  getParentRoute: () => MenuRoute,
} as any)
const MenuAddonsNewRoute = MenuAddonsNewRouteImport.update({
  id: '/addons/new',
  path: '/addons/new',
  getParentRoute: () => MenuRoute,
} as any)
const MenuCategoriesIndexRoute = MenuCategoriesIndexRouteImport.update({
  id: '/categories/',
  path: '/categories/',
  getParentRoute: () => MenuRoute,
} as any)
const MenuCategoriesCategoryIdRoute =
  MenuCategoriesCategoryIdRouteImport.update({
    id: '/categories/$categoryId',
    path: '/categories/$categoryId',
    getParentRoute: () => MenuRoute,
  } as any)
const MenuCategoriesNewRoute = MenuCategoriesNewRouteImport.update({
  id: '/categories/new',
  path: '/categories/new',
  getParentRoute: () => MenuRoute,
} as any)
const MenuItemsItemIdRoute = MenuItemsItemIdRouteImport.update({
  id: '/items/$itemId',
  path: '/items/$itemId',
  getParentRoute: () => MenuRoute,
} as any)
const MenuItemsNewRoute = MenuItemsNewRouteImport.update({
  id: '/items/new',
  path: '/items/new',
  getParentRoute: () => MenuRoute,
} as any)
const MoreBillsIndexRoute = MoreBillsIndexRouteImport.update({
  id: '/more/bills/',
  path: '/more/bills/',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreBillsBillIdRoute = MoreBillsBillIdRouteImport.update({
  id: '/more/bills/$billId',
  path: '/more/bills/$billId',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreOffersIndexRoute = MoreOffersIndexRouteImport.update({
  id: '/more/offers/',
  path: '/more/offers/',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreOffersOfferIdRoute = MoreOffersOfferIdRouteImport.update({
  id: '/more/offers/$offerId',
  path: '/more/offers/$offerId',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreOffersNewRoute = MoreOffersNewRouteImport.update({
  id: '/more/offers/new',
  path: '/more/offers/new',
  getParentRoute: () => rootRouteImport,
} as any)
const MorePrintersIndexRoute = MorePrintersIndexRouteImport.update({
  id: '/more/printers/',
  path: '/more/printers/',
  getParentRoute: () => rootRouteImport,
} as any)
const MorePrintersPrinterIdRoute = MorePrintersPrinterIdRouteImport.update({
  id: '/more/printers/$printerId',
  path: '/more/printers/$printerId',
  getParentRoute: () => rootRouteImport,
} as any)
const MorePrintersBridgeRoute = MorePrintersBridgeRouteImport.update({
  id: '/more/printers/bridge',
  path: '/more/printers/bridge',
  getParentRoute: () => rootRouteImport,
} as any)
const MorePrintersJobsRoute = MorePrintersJobsRouteImport.update({
  id: '/more/printers/jobs',
  path: '/more/printers/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const MorePrintersNewRoute = MorePrintersNewRouteImport.update({
  id: '/more/printers/new',
  path: '/more/printers/new',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreReportsIndexRoute = MoreReportsIndexRouteImport.update({
  id: '/more/reports/',
  path: '/more/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const MoreReportsReportRoute = MoreReportsReportRouteImport.update({
  id: '/more/reports/$report',
  path: '/more/reports/$report',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdBillRoute = OrdersOrderIdBillRouteImport.update({
  id: '/$orderId_/bill',
  path: '/$orderId/bill',
  getParentRoute: () => OrdersRoute,
} as any)
const OrdersOrderIdPayRoute = OrdersOrderIdPayRouteImport.update({
  id: '/$orderId_/pay',
  path: '/$orderId/pay',
  getParentRoute: () => OrdersRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bill': typeof BillRoute
  '/menu': typeof MenuRouteWithChildren
  '/orders': typeof OrdersRouteWithChildren
  '/sso-callback': typeof SsoCallbackRoute
  '/support': typeof SupportRoute
  '/tables': typeof TablesRoute
  '/join/$code': typeof JoinCodeRoute
  '/more/activity': typeof MoreActivityRoute
  '/more/billing': typeof MoreBillingRoute
  '/more/day-close': typeof MoreDayCloseRoute
  '/more/device': typeof MoreDeviceRoute
  '/more/ordering': typeof MoreOrderingRoute
  '/more/profile': typeof MoreProfileRoute
  '/more/staff': typeof MoreStaffRoute
  '/more/subscription': typeof MoreSubscriptionRoute
  '/more/switch': typeof MoreSwitchRoute
  '/more/tables': typeof MoreTablesRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/orders/kots': typeof OrdersKotsRoute
  '/orders/new': typeof OrdersNewRoute
  '/join/': typeof JoinIndexRoute
  '/menu/': typeof MenuIndexRoute
  '/more/': typeof MoreIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/menu/addons/$groupId': typeof MenuAddonsGroupIdRoute
  '/menu/addons/new': typeof MenuAddonsNewRoute
  '/menu/categories/$categoryId': typeof MenuCategoriesCategoryIdRoute
  '/menu/categories/new': typeof MenuCategoriesNewRoute
  '/menu/items/$itemId': typeof MenuItemsItemIdRoute
  '/menu/items/new': typeof MenuItemsNewRoute
  '/more/bills/$billId': typeof MoreBillsBillIdRoute
  '/more/offers/$offerId': typeof MoreOffersOfferIdRoute
  '/more/offers/new': typeof MoreOffersNewRoute
  '/more/printers/$printerId': typeof MorePrintersPrinterIdRoute
  '/more/printers/bridge': typeof MorePrintersBridgeRoute
  '/more/printers/jobs': typeof MorePrintersJobsRoute
  '/more/printers/new': typeof MorePrintersNewRoute
  '/more/reports/$report': typeof MoreReportsReportRoute
  '/orders/$orderId/bill': typeof OrdersOrderIdBillRoute
  '/orders/$orderId/pay': typeof OrdersOrderIdPayRoute
  '/menu/addons/': typeof MenuAddonsIndexRoute
  '/menu/categories/': typeof MenuCategoriesIndexRoute
  '/more/bills/': typeof MoreBillsIndexRoute
  '/more/offers/': typeof MoreOffersIndexRoute
  '/more/printers/': typeof MorePrintersIndexRoute
  '/more/reports/': typeof MoreReportsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bill': typeof BillRoute
  '/sso-callback': typeof SsoCallbackRoute
  '/support': typeof SupportRoute
  '/tables': typeof TablesRoute
  '/join/$code': typeof JoinCodeRoute
  '/more/activity': typeof MoreActivityRoute
  '/more/billing': typeof MoreBillingRoute
  '/more/day-close': typeof MoreDayCloseRoute
  '/more/device': typeof MoreDeviceRoute
  '/more/ordering': typeof MoreOrderingRoute
  '/more/profile': typeof MoreProfileRoute
  '/more/staff': typeof MoreStaffRoute
  '/more/subscription': typeof MoreSubscriptionRoute
  '/more/switch': typeof MoreSwitchRoute
  '/more/tables': typeof MoreTablesRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/orders/kots': typeof OrdersKotsRoute
  '/orders/new': typeof OrdersNewRoute
  '/join': typeof JoinIndexRoute
  '/menu': typeof MenuIndexRoute
  '/more': typeof MoreIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/menu/addons/$groupId': typeof MenuAddonsGroupIdRoute
  '/menu/addons/new': typeof MenuAddonsNewRoute
  '/menu/categories/$categoryId': typeof MenuCategoriesCategoryIdRoute
  '/menu/categories/new': typeof MenuCategoriesNewRoute
  '/menu/items/$itemId': typeof MenuItemsItemIdRoute
  '/menu/items/new': typeof MenuItemsNewRoute
  '/more/bills/$billId': typeof MoreBillsBillIdRoute
  '/more/offers/$offerId': typeof MoreOffersOfferIdRoute
  '/more/offers/new': typeof MoreOffersNewRoute
  '/more/printers/$printerId': typeof MorePrintersPrinterIdRoute
  '/more/printers/bridge': typeof MorePrintersBridgeRoute
  '/more/printers/jobs': typeof MorePrintersJobsRoute
  '/more/printers/new': typeof MorePrintersNewRoute
  '/more/reports/$report': typeof MoreReportsReportRoute
  '/orders/$orderId/bill': typeof OrdersOrderIdBillRoute
  '/orders/$orderId/pay': typeof OrdersOrderIdPayRoute
  '/menu/addons': typeof MenuAddonsIndexRoute
  '/menu/categories': typeof MenuCategoriesIndexRoute
  '/more/bills': typeof MoreBillsIndexRoute
  '/more/offers': typeof MoreOffersIndexRoute
  '/more/printers': typeof MorePrintersIndexRoute
  '/more/reports': typeof MoreReportsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/bill': typeof BillRoute
  '/menu': typeof MenuRouteWithChildren
  '/orders': typeof OrdersRouteWithChildren
  '/sso-callback': typeof SsoCallbackRoute
  '/support': typeof SupportRoute
  '/tables': typeof TablesRoute
  '/join/$code': typeof JoinCodeRoute
  '/more/activity': typeof MoreActivityRoute
  '/more/billing': typeof MoreBillingRoute
  '/more/day-close': typeof MoreDayCloseRoute
  '/more/device': typeof MoreDeviceRoute
  '/more/ordering': typeof MoreOrderingRoute
  '/more/profile': typeof MoreProfileRoute
  '/more/staff': typeof MoreStaffRoute
  '/more/subscription': typeof MoreSubscriptionRoute
  '/more/switch': typeof MoreSwitchRoute
  '/more/tables': typeof MoreTablesRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/orders/kots': typeof OrdersKotsRoute
  '/orders/new': typeof OrdersNewRoute
  '/join/': typeof JoinIndexRoute
  '/menu/': typeof MenuIndexRoute
  '/more/': typeof MoreIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/menu/addons/$groupId': typeof MenuAddonsGroupIdRoute
  '/menu/addons/new': typeof MenuAddonsNewRoute
  '/menu/categories/$categoryId': typeof MenuCategoriesCategoryIdRoute
  '/menu/categories/new': typeof MenuCategoriesNewRoute
  '/menu/items/$itemId': typeof MenuItemsItemIdRoute
  '/menu/items/new': typeof MenuItemsNewRoute
  '/more/bills/$billId': typeof MoreBillsBillIdRoute
  '/more/offers/$offerId': typeof MoreOffersOfferIdRoute
  '/more/offers/new': typeof MoreOffersNewRoute
  '/more/printers/$printerId': typeof MorePrintersPrinterIdRoute
  '/more/printers/bridge': typeof MorePrintersBridgeRoute
  '/more/printers/jobs': typeof MorePrintersJobsRoute
  '/more/printers/new': typeof MorePrintersNewRoute
  '/more/reports/$report': typeof MoreReportsReportRoute
  '/orders/$orderId_/bill': typeof OrdersOrderIdBillRoute
  '/orders/$orderId_/pay': typeof OrdersOrderIdPayRoute
  '/menu/addons/': typeof MenuAddonsIndexRoute
  '/menu/categories/': typeof MenuCategoriesIndexRoute
  '/more/bills/': typeof MoreBillsIndexRoute
  '/more/offers/': typeof MoreOffersIndexRoute
  '/more/printers/': typeof MorePrintersIndexRoute
  '/more/reports/': typeof MoreReportsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bill'
    | '/menu'
    | '/orders'
    | '/sso-callback'
    | '/support'
    | '/tables'
    | '/join/$code'
    | '/more/activity'
    | '/more/billing'
    | '/more/day-close'
    | '/more/device'
    | '/more/ordering'
    | '/more/profile'
    | '/more/staff'
    | '/more/subscription'
    | '/more/switch'
    | '/more/tables'
    | '/orders/$orderId'
    | '/orders/kots'
    | '/orders/new'
    | '/join/'
    | '/menu/'
    | '/more/'
    | '/orders/'
    | '/menu/addons/$groupId'
    | '/menu/addons/new'
    | '/menu/categories/$categoryId'
    | '/menu/categories/new'
    | '/menu/items/$itemId'
    | '/menu/items/new'
    | '/more/bills/$billId'
    | '/more/offers/$offerId'
    | '/more/offers/new'
    | '/more/printers/$printerId'
    | '/more/printers/bridge'
    | '/more/printers/jobs'
    | '/more/printers/new'
    | '/more/reports/$report'
    | '/orders/$orderId/bill'
    | '/orders/$orderId/pay'
    | '/menu/addons/'
    | '/menu/categories/'
    | '/more/bills/'
    | '/more/offers/'
    | '/more/printers/'
    | '/more/reports/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bill'
    | '/sso-callback'
    | '/support'
    | '/tables'
    | '/join/$code'
    | '/more/activity'
    | '/more/billing'
    | '/more/day-close'
    | '/more/device'
    | '/more/ordering'
    | '/more/profile'
    | '/more/staff'
    | '/more/subscription'
    | '/more/switch'
    | '/more/tables'
    | '/orders/$orderId'
    | '/orders/kots'
    | '/orders/new'
    | '/join'
    | '/menu'
    | '/more'
    | '/orders'
    | '/menu/addons/$groupId'
    | '/menu/addons/new'
    | '/menu/categories/$categoryId'
    | '/menu/categories/new'
    | '/menu/items/$itemId'
    | '/menu/items/new'
    | '/more/bills/$billId'
    | '/more/offers/$offerId'
    | '/more/offers/new'
    | '/more/printers/$printerId'
    | '/more/printers/bridge'
    | '/more/printers/jobs'
    | '/more/printers/new'
    | '/more/reports/$report'
    | '/orders/$orderId/bill'
    | '/orders/$orderId/pay'
    | '/menu/addons'
    | '/menu/categories'
    | '/more/bills'
    | '/more/offers'
    | '/more/printers'
    | '/more/reports'
  id:
    | '__root__'
    | '/'
    | '/bill'
    | '/menu'
    | '/orders'
    | '/sso-callback'
    | '/support'
    | '/tables'
    | '/join/$code'
    | '/more/activity'
    | '/more/billing'
    | '/more/day-close'
    | '/more/device'
    | '/more/ordering'
    | '/more/profile'
    | '/more/staff'
    | '/more/subscription'
    | '/more/switch'
    | '/more/tables'
    | '/orders/$orderId'
    | '/orders/kots'
    | '/orders/new'
    | '/join/'
    | '/menu/'
    | '/more/'
    | '/orders/'
    | '/menu/addons/$groupId'
    | '/menu/addons/new'
    | '/menu/categories/$categoryId'
    | '/menu/categories/new'
    | '/menu/items/$itemId'
    | '/menu/items/new'
    | '/more/bills/$billId'
    | '/more/offers/$offerId'
    | '/more/offers/new'
    | '/more/printers/$printerId'
    | '/more/printers/bridge'
    | '/more/printers/jobs'
    | '/more/printers/new'
    | '/more/reports/$report'
    | '/orders/$orderId_/bill'
    | '/orders/$orderId_/pay'
    | '/menu/addons/'
    | '/menu/categories/'
    | '/more/bills/'
    | '/more/offers/'
    | '/more/printers/'
    | '/more/reports/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BillRoute: typeof BillRoute
  MenuRoute: typeof MenuRouteWithChildren
  OrdersRoute: typeof OrdersRouteWithChildren
  SsoCallbackRoute: typeof SsoCallbackRoute
  SupportRoute: typeof SupportRoute
  TablesRoute: typeof TablesRoute
  JoinCodeRoute: typeof JoinCodeRoute
  MoreActivityRoute: typeof MoreActivityRoute
  MoreBillingRoute: typeof MoreBillingRoute
  MoreDayCloseRoute: typeof MoreDayCloseRoute
  MoreDeviceRoute: typeof MoreDeviceRoute
  MoreOrderingRoute: typeof MoreOrderingRoute
  MoreProfileRoute: typeof MoreProfileRoute
  MoreStaffRoute: typeof MoreStaffRoute
  MoreSubscriptionRoute: typeof MoreSubscriptionRoute
  MoreSwitchRoute: typeof MoreSwitchRoute
  MoreTablesRoute: typeof MoreTablesRoute
  JoinIndexRoute: typeof JoinIndexRoute
  MoreIndexRoute: typeof MoreIndexRoute
  MoreBillsBillIdRoute: typeof MoreBillsBillIdRoute
  MoreOffersOfferIdRoute: typeof MoreOffersOfferIdRoute
  MoreOffersNewRoute: typeof MoreOffersNewRoute
  MorePrintersPrinterIdRoute: typeof MorePrintersPrinterIdRoute
  MorePrintersBridgeRoute: typeof MorePrintersBridgeRoute
  MorePrintersJobsRoute: typeof MorePrintersJobsRoute
  MorePrintersNewRoute: typeof MorePrintersNewRoute
  MoreReportsReportRoute: typeof MoreReportsReportRoute
  MoreBillsIndexRoute: typeof MoreBillsIndexRoute
  MoreOffersIndexRoute: typeof MoreOffersIndexRoute
  MorePrintersIndexRoute: typeof MorePrintersIndexRoute
  MoreReportsIndexRoute: typeof MoreReportsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bill': {
      id: '/bill'
      path: '/bill'
      fullPath: '/bill'
      preLoaderRoute: typeof BillRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu': {
      id: '/menu'
      path: '/menu'
      fullPath: '/menu'
      preLoaderRoute: typeof MenuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders': {
      id: '/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-callback': {
      id: '/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof SsoCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tables': {
      id: '/tables'
      path: '/tables'
      fullPath: '/tables'
      preLoaderRoute: typeof TablesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/': {
      id: '/join/'
      path: '/join'
      fullPath: '/join/'
      preLoaderRoute: typeof JoinIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$code': {
      id: '/join/$code'
      path: '/join/$code'
      fullPath: '/join/$code'
      preLoaderRoute: typeof JoinCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/menu/': {
      id: '/menu/'
      path: '/'
      fullPath: '/menu/'
      preLoaderRoute: typeof MenuIndexRouteImport
      parentRoute: typeof MenuRoute
    }
    '/more/': {
      id: '/more/'
      path: '/more'
      fullPath: '/more/'
      preLoaderRoute: typeof MoreIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/activity': {
      id: '/more/activity'
      path: '/more/activity'
      fullPath: '/more/activity'
      preLoaderRoute: typeof MoreActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/billing': {
      id: '/more/billing'
      path: '/more/billing'
      fullPath: '/more/billing'
      preLoaderRoute: typeof MoreBillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/day-close': {
      id: '/more/day-close'
      path: '/more/day-close'
      fullPath: '/more/day-close'
      preLoaderRoute: typeof MoreDayCloseRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/device': {
      id: '/more/device'
      path: '/more/device'
      fullPath: '/more/device'
      preLoaderRoute: typeof MoreDeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/ordering': {
      id: '/more/ordering'
      path: '/more/ordering'
      fullPath: '/more/ordering'
      preLoaderRoute: typeof MoreOrderingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/profile': {
      id: '/more/profile'
      path: '/more/profile'
      fullPath: '/more/profile'
      preLoaderRoute: typeof MoreProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/staff': {
      id: '/more/staff'
      path: '/more/staff'
      fullPath: '/more/staff'
      preLoaderRoute: typeof MoreStaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/subscription': {
      id: '/more/subscription'
      path: '/more/subscription'
      fullPath: '/more/subscription'
      preLoaderRoute: typeof MoreSubscriptionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/switch': {
      id: '/more/switch'
      path: '/more/switch'
      fullPath: '/more/switch'
      preLoaderRoute: typeof MoreSwitchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/tables': {
      id: '/more/tables'
      path: '/more/tables'
      fullPath: '/more/tables'
      preLoaderRoute: typeof MoreTablesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/orders/kots': {
      id: '/orders/kots'
      path: '/kots'
      fullPath: '/orders/kots'
      preLoaderRoute: typeof OrdersKotsRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/orders/new': {
      id: '/orders/new'
      path: '/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof OrdersNewRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/menu/addons/': {
      id: '/menu/addons/'
      path: '/addons'
      fullPath: '/menu/addons/'
      preLoaderRoute: typeof MenuAddonsIndexRouteImport
      parentRoute: typeof MenuRoute
    }
    '/menu/addons/$groupId': {
      id: '/menu/addons/$groupId'
      path: '/addons/$groupId'
      fullPath: '/menu/addons/$groupId'
      preLoaderRoute: typeof MenuAddonsGroupIdRouteImport
      parentRoute: typeof MenuRoute
    }
    '/menu/addons/new': {
      id: '/menu/addons/new'
      path: '/addons/new'
      fullPath: '/menu/addons/new'
      preLoaderRoute: typeof MenuAddonsNewRouteImport
      parentRoute: typeof MenuRoute
    }
    '/menu/categories/': {
      id: '/menu/categories/'
      path: '/categories'
      fullPath: '/menu/categories/'
      preLoaderRoute: typeof MenuCategoriesIndexRouteImport
      parentRoute: typeof MenuRoute
    }
    '/menu/categories/$categoryId': {
      id: '/menu/categories/$categoryId'
      path: '/categories/$categoryId'
      fullPath: '/menu/categories/$categoryId'
      preLoaderRoute: typeof MenuCategoriesCategoryIdRouteImport
      parentRoute: typeof MenuRoute
    }
    '/menu/categories/new': {
      id: '/menu/categories/new'
      path: '/categories/new'
      fullPath: '/menu/categories/new'
      preLoaderRoute: typeof MenuCategoriesNewRouteImport
      parentRoute: typeof MenuRoute
    }
    '/menu/items/$itemId': {
      id: '/menu/items/$itemId'
      path: '/items/$itemId'
      fullPath: '/menu/items/$itemId'
      preLoaderRoute: typeof MenuItemsItemIdRouteImport
      parentRoute: typeof MenuRoute
    }
    '/menu/items/new': {
      id: '/menu/items/new'
      path: '/items/new'
      fullPath: '/menu/items/new'
      preLoaderRoute: typeof MenuItemsNewRouteImport
      parentRoute: typeof MenuRoute
    }
    '/more/bills/': {
      id: '/more/bills/'
      path: '/more/bills'
      fullPath: '/more/bills/'
      preLoaderRoute: typeof MoreBillsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/bills/$billId': {
      id: '/more/bills/$billId'
      path: '/more/bills/$billId'
      fullPath: '/more/bills/$billId'
      preLoaderRoute: typeof MoreBillsBillIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/offers/': {
      id: '/more/offers/'
      path: '/more/offers'
      fullPath: '/more/offers/'
      preLoaderRoute: typeof MoreOffersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/offers/$offerId': {
      id: '/more/offers/$offerId'
      path: '/more/offers/$offerId'
      fullPath: '/more/offers/$offerId'
      preLoaderRoute: typeof MoreOffersOfferIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/offers/new': {
      id: '/more/offers/new'
      path: '/more/offers/new'
      fullPath: '/more/offers/new'
      preLoaderRoute: typeof MoreOffersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/printers/': {
      id: '/more/printers/'
      path: '/more/printers'
      fullPath: '/more/printers/'
      preLoaderRoute: typeof MorePrintersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/printers/$printerId': {
      id: '/more/printers/$printerId'
      path: '/more/printers/$printerId'
      fullPath: '/more/printers/$printerId'
      preLoaderRoute: typeof MorePrintersPrinterIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/printers/bridge': {
      id: '/more/printers/bridge'
      path: '/more/printers/bridge'
      fullPath: '/more/printers/bridge'
      preLoaderRoute: typeof MorePrintersBridgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/printers/jobs': {
      id: '/more/printers/jobs'
      path: '/more/printers/jobs'
      fullPath: '/more/printers/jobs'
      preLoaderRoute: typeof MorePrintersJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/printers/new': {
      id: '/more/printers/new'
      path: '/more/printers/new'
      fullPath: '/more/printers/new'
      preLoaderRoute: typeof MorePrintersNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/reports/': {
      id: '/more/reports/'
      path: '/more/reports'
      fullPath: '/more/reports/'
      preLoaderRoute: typeof MoreReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/more/reports/$report': {
      id: '/more/reports/$report'
      path: '/more/reports/$report'
      fullPath: '/more/reports/$report'
      preLoaderRoute: typeof MoreReportsReportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId_/bill': {
      id: '/orders/$orderId_/bill'
      path: '/$orderId/bill'
      fullPath: '/orders/$orderId/bill'
      preLoaderRoute: typeof OrdersOrderIdBillRouteImport
      parentRoute: typeof OrdersRoute
    }
    '/orders/$orderId_/pay': {
      id: '/orders/$orderId_/pay'
      path: '/$orderId/pay'
      fullPath: '/orders/$orderId/pay'
      preLoaderRoute: typeof OrdersOrderIdPayRouteImport
      parentRoute: typeof OrdersRoute
    }
  }
}

interface MenuRouteChildren {
  MenuIndexRoute: typeof MenuIndexRoute
  MenuAddonsGroupIdRoute: typeof MenuAddonsGroupIdRoute
  MenuAddonsNewRoute: typeof MenuAddonsNewRoute
  MenuCategoriesCategoryIdRoute: typeof MenuCategoriesCategoryIdRoute
  MenuCategoriesNewRoute: typeof MenuCategoriesNewRoute
  MenuItemsItemIdRoute: typeof MenuItemsItemIdRoute
  MenuItemsNewRoute: typeof MenuItemsNewRoute
  MenuAddonsIndexRoute: typeof MenuAddonsIndexRoute
  MenuCategoriesIndexRoute: typeof MenuCategoriesIndexRoute
}

const MenuRouteChildren: MenuRouteChildren = {
  MenuIndexRoute: MenuIndexRoute,
  MenuAddonsGroupIdRoute: MenuAddonsGroupIdRoute,
  MenuAddonsNewRoute: MenuAddonsNewRoute,
  MenuCategoriesCategoryIdRoute: MenuCategoriesCategoryIdRoute,
  MenuCategoriesNewRoute: MenuCategoriesNewRoute,
  MenuItemsItemIdRoute: MenuItemsItemIdRoute,
  MenuItemsNewRoute: MenuItemsNewRoute,
  MenuAddonsIndexRoute: MenuAddonsIndexRoute,
  MenuCategoriesIndexRoute: MenuCategoriesIndexRoute,
}

const MenuRouteWithChildren = MenuRoute._addFileChildren(MenuRouteChildren)

interface OrdersRouteChildren {
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
  OrdersKotsRoute: typeof OrdersKotsRoute
  OrdersNewRoute: typeof OrdersNewRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  OrdersOrderIdBillRoute: typeof OrdersOrderIdBillRoute
  OrdersOrderIdPayRoute: typeof OrdersOrderIdPayRoute
}

const OrdersRouteChildren: OrdersRouteChildren = {
  OrdersOrderIdRoute: OrdersOrderIdRoute,
  OrdersKotsRoute: OrdersKotsRoute,
  OrdersNewRoute: OrdersNewRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  OrdersOrderIdBillRoute: OrdersOrderIdBillRoute,
  OrdersOrderIdPayRoute: OrdersOrderIdPayRoute,
}

const OrdersRouteWithChildren =
  OrdersRoute._addFileChildren(OrdersRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BillRoute: BillRoute,
  MenuRoute: MenuRouteWithChildren,
  OrdersRoute: OrdersRouteWithChildren,
  SsoCallbackRoute: SsoCallbackRoute,
  SupportRoute: SupportRoute,
  TablesRoute: TablesRoute,
  JoinCodeRoute: JoinCodeRoute,
  MoreActivityRoute: MoreActivityRoute,
  MoreBillingRoute: MoreBillingRoute,
  MoreDayCloseRoute: MoreDayCloseRoute,
  MoreDeviceRoute: MoreDeviceRoute,
  MoreOrderingRoute: MoreOrderingRoute,
  MoreProfileRoute: MoreProfileRoute,
  MoreStaffRoute: MoreStaffRoute,
  MoreSubscriptionRoute: MoreSubscriptionRoute,
  MoreSwitchRoute: MoreSwitchRoute,
  MoreTablesRoute: MoreTablesRoute,
  JoinIndexRoute: JoinIndexRoute,
  MoreIndexRoute: MoreIndexRoute,
  MoreBillsBillIdRoute: MoreBillsBillIdRoute,
  MoreOffersOfferIdRoute: MoreOffersOfferIdRoute,
  MoreOffersNewRoute: MoreOffersNewRoute,
  MorePrintersPrinterIdRoute: MorePrintersPrinterIdRoute,
  MorePrintersBridgeRoute: MorePrintersBridgeRoute,
  MorePrintersJobsRoute: MorePrintersJobsRoute,
  MorePrintersNewRoute: MorePrintersNewRoute,
  MoreReportsReportRoute: MoreReportsReportRoute,
  MoreBillsIndexRoute: MoreBillsIndexRoute,
  MoreOffersIndexRoute: MoreOffersIndexRoute,
  MorePrintersIndexRoute: MorePrintersIndexRoute,
  MoreReportsIndexRoute: MoreReportsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
